const es = {
  questionPaperLibrary: "Biblioteca de cuestionarios",
  questionPaperLibraryDescription:
    "Tu espacio de trabajo dinamico para crear preguntas individuales y disenar cuestionarios completos.",
  assessmentLibrary: "Biblioteca de evaluaciones",
  assessmentLibraryDescription:
    "Gestiona cronogramas, invita participantes y realiza seguimiento de reportes de rendimiento en un unico espacio centralizado.",
  myAssessmentWidgetTitle: "Mi evaluacion",
  myPreferences: "Mis preferencias",
  assessmentsForYou: "Evaluaciones para ti",
  exploreAssessmentsAssignedToYou: "Explora las evaluaciones asignadas a ti",
  hitachiAcademy: "Academia Hitachi",
  essentialBusinessKnowledgeTestForYou:
    "Prueba esencial de conocimiento empresarial para ti",
  continuousLearningJourneyDescription:
    "Disenado para ayudarte a comprender y fortalecer tus habilidades empresariales a lo largo de tu aprendizaje continuo",
  noActiveAssessmentsScheduledForYou:
    "No hay evaluaciones activas programadas para ti",
  upcoming: "Proximamente",
  notAttempted: "No intentado",
  myAssessmentCardDescription:
    "Esta evaluacion mide tus habilidades tecnicas, analiticas y de resolucion de problemas como parte del proceso de contratacion universitaria de GlobalLogic.",
  totalDuration: "Duracion total",
  startTime: "Hora de inicio",
  questionAuthoring: "Creacion de preguntas",
  reviewQuestions: "Revisar preguntas",
  bulkUploadHistory: "Historial de carga masiva",
  bulkActionHistory: "Historial de acciones masivas",
  editQuestion: "Editar pregunta",
  inviteParticipants: "Invitar participantes",
  externalUserBulkUploadHistory:
    "Historial de carga masiva de usuarios externos",
  assessmentSchedule: "Programacion de evaluacion",
  assessmentReport: "Informe de evaluacion",
  bulkHistory: "Historial masivo",
  myUpload: "Mi carga",
  bulkUpload: "Carga masiva",
  createQuestion: "Crear pregunta",
  bulkUploadQuestions: "Carga masiva de preguntas",
  filters: "Filtros",
  clear: "Limpiar",
  searchByTitle: "Buscar por titulo",
  refresh: "Actualizar",
  refreshing: "Actualizando",
  reviewQuestionPapers: "Revisar cuestionarios",
  myQuestionPapers: "Mis cuestionarios",
  viewQuestionBank: "Ver banco de preguntas",
  createNew: "Crear nuevo",
  sortBy: "Ordenar por",
  state: "Estado",
  reviewed: "Revisado",
  reviewedTooltip:
    "Mostrar cuestionarios que han sido revisados y luego publicados.",
  all: "Todos",
  draft: "Borrador",
  published: "Publicado",
  inReview: "En revision",
  sentBack: "Devuelto",
  readyToPublish: "Listo para publicar",
  draftDescription:
    "La creacion del cuestionario aun esta en curso y todavia no esta disponible para los alumnos",
  publishedDescription:
    "El cuestionario esta activo y accesible para los alumnos",
  inReviewDescription:
    "El cuestionario esta en revision y aun no ha sido aprobado",
  sentBackDescription: "El cuestionario fue devuelto para revisiones",
  readyToPublishDescription: "El cuestionario esta listo para publicarse",
  createdAt: "Creado el",
  updatedAt: "Actualizado el",
  publishedAt: "Publicado el",
  descending: "Descendente",
  ascending: "Ascendente",
  success: "Éxito",
  error: "Error",
  warning: "Advertencia",
  info: "Información",
  yes: "Si",
  no: "No",
  noMatchingContentFound: "No se encontro contenido coincidente",
  noQuestionPapersAvailableForReview:
    "No hay cuestionarios disponibles para revision",
  questionPaperNotYetCreated: "El cuestionario aun no se ha creado",
  createQuestionPaperDescription:
    "Crea un cuestionario para evaluar las habilidades y conocimientos de los alumnos",
  createYourFirstQuestionPaper: "Crea tu primer cuestionario",
  createQuestionPaperModalTitle: "Crear cuestionario",
  questionsTab: "Preguntas",
  questionPaperSettingsTab: "Configuración del cuestionario",
  editQuestionPaper: "Editar cuestionario",
  save: "Guardar",
  publish: "Publicar",
  sendForReview: "Enviar para revisión",
  sendingForReview: "Envío para revisión",
  publishing: "Publicación",
  clone: "Clon",
  delete: "Borrar",
  view: "Vista",
  edit: "Editar",
  close: "Cerca",
  create: "Crear",
  creating: "Creando",
  confirm: "Confirmar",
  cancel: "Cancelar",
  version: "Versión",
  untitled: "Sin título",
  noVersion: "Sin versión",
  title: "Título",
  status: "Estado",
  action: "Acción",
  createdBy: "Creado por",
  createNewVersion: "+ Nueva versión",
  createNewVersionTitle: "Crear nueva versión",
  deleteQuestionPaperPrompt:
    "¿Está seguro de que desea eliminar este cuestionario?",
  deleteQuestionPaperWithTitlePrompt:
    "¿Quiere eliminar este cuestionario titulado '{{title}}'?",
  cloneQuestionPaperPrompt: "¿Quieres clonar este cuestionario?",
  publishQuestionPaperPrompt:
    "¿Está seguro de que desea publicar este cuestionario?",
  sendForReviewQuestionPaperPrompt:
    "¿Está seguro de que desea enviar este cuestionario para su revisión?",
  successfullyDeletedQuestionPaper: "Se eliminó correctamente el cuestionario.",
  successfullyMovedQuestionPaperToDraft:
    "Se movió correctamente el cuestionario al borrador.",
  successfullySavedQuestionPaperData:
    "Datos del cuestionario guardados correctamente",
  successfullyClonedQuestionPaper: "Cloné con éxito el cuestionario.",
  successfullyCreatedQuestionPaper: "Creó exitosamente el cuestionario.",
  validationFailedWithFollowingErrors:
    "La validación falló con los siguientes errores:",
  failedStatusUpdateOf: "Actualización de estado fallida de:",
  savedWithFollowingWarnings: "Guardado con las siguientes advertencias:",
  reviewedAndPublished: "Revisado y publicado",
  deleting: "Eliminando...",
  cloning: "Clonación...",
  assessment: "Evaluación",
  public: "Público",
  private: "Privado",
  visibility: "Visibilidad",
  questionType: "Tipo de pregunta",
  selectQuestionTypeAndVisibility:
    "Seleccione el tipo de pregunta y la visibilidad",
  singleChoice: "Elección única",
  multipleChoice: "Opción múltiple",
  trueOrFalse: "Verdadero o Falso",
  fillInTheBlanks: "Completa los espacios en blanco",
  codingQuestion: "Pregunta de codificación",
  subjectiveQuestion: "Pregunta subjetiva",
  speakingQuestion: "pregunta oral",
  downloadTemplateEditAndReuploadQuestions:
    "Descargar plantilla, editar y volver a cargar la lista de preguntas",
  downloadExcelTemplateInstruction:
    "Descargue la plantilla de Excel usando el botón a continuación.",
  addQuestionsToSheetInstruction:
    "Agregue sus preguntas a la hoja (las instrucciones están incluidas en el interior).",
  uploadCompletedExcelInstruction:
    "Cargue el archivo Excel completo para importar preguntas de forma masiva.",
  uploading: "Subiendo...",
  uploadQuestions: "Subir preguntas",
  completed: "Terminado",
  invalid: "Inválido",
  initiated: "Iniciado",
  failed: "Fallido",
  fileName: "Nombre del archivo",
  templateType: "Tipo de plantilla",
  uploadedAt: "Subido en",
  actions: "Comportamiento",
  mcqTemplate: "Plantilla de MCQ",
  fibTemplate: "Plantilla FIB",
  monitorUploadExcelDescription:
    "Supervise cada archivo de Excel cargado, verifique cuántas preguntas se agregaron o fallaron y vea los detalles del error si es necesario.",
  reset: "Reiniciar",
  showing: "Mostrando",
  to: "a",
  of: "de",
  results: "resultados",
  noExcelFound: "No se encontró Excel",
  cloneAssessmentConfirmation: "Confirmación de evaluación de clonación",
  cloneAssessmentWithTitlePrompt:
    "¿Está seguro de que desea clonar esta evaluación titulada '{{title}}'?",
  successfullyClonedAssessment: "Evaluación clonada con éxito",
  newVersionContentPrompt:
    "Estás a punto de crear una nueva versión de este contenido. Cualquier cambio adicional se guardará en esta versión. ¿Quieres continuar?",
  createVersionWithNumber: "Crear (V{{version}})",
  addYourComment: "Añade tu comentario",
  maxLimitReached: "límite máximo alcanzado",
  deleteContentPrompt:
    "¿Estás seguro de que deseas eliminar este {{contentType}}?",
  deleteContentWithTitlePrompt:
    "¿Está seguro de que desea eliminar este {{contentType}} titulado '{{title}}'?",
  schedulePreview: "Vista previa del programa",
  reschedule: "Reprogramar",
  cancelled: "Cancelado",
  copyLink: "Copiar enlace",
  assessmentIsCancelled: "Se cancela la evaluación",
  deleteConfirmation: "Eliminar confirmación",
  cancelConfirmation: "Cancelar confirmación",
  deleteAssessmentPrompt: "¿Está seguro de que desea eliminar esta evaluación?",
  cancelAssessmentPrompt:
    "¿Estás seguro de que deseas cancelar esta evaluación?",
  rescheduleAssessment: "Reprogramar evaluación",
  customTermsAndConditions: "Términos y condiciones personalizados",
  viewTermsAndConditions: "Ver términos y condiciones",
  scheduleNewAssessment: "Programar nueva evaluación",
  selectQuestionPaper: "Seleccionar cuestionario",
  createAssessment: "Crear evaluación",
  failedToLoadData: "¡No se pudieron cargar los datos!",
  assessmentNotYetCreated: "Evaluación aún no creada",
  createAssessmentDescription:
    "Crear una evaluación para evaluar las habilidades y conocimientos de los alumnos.",
  createYourFirstAssessment: "Crea tu primera evaluación",
  failedToLoadSchedules: "No se pudieron cargar los horarios",
  errors: "Errores:",
  basicInformation: "Información básica",
  assessmentName: "Nombre de la evaluación",
  na: "N / A",
  scheduleInstructions: "Instrucciones de programación",
  noInstructionsProvided: "No se proporcionan instrucciones",
  accessCriteria: "Criterios de acceso",
  searchTags: "Buscar etiquetas",
  viewAttributes: "Ver atributos",
  termsAndConditions: "Términos y condiciones",
  enabled: "Activado",
  disabled: "Desactivado",
  requireCandidatesToAcceptTerms:
    "Requerir que los candidatos acepten los T&C antes de comenzar la evaluación",
  proctoringSettings: "Configuración de supervisión",
  enableVideoProctoring: "Habilitar supervisión de vídeo",
  maximumVideoViolationsAllowed: "Máximas infracciones de vídeo permitidas",
  enableBrowserProctoring: "Habilitar la supervisión del navegador",
  maximumBrowserViolationsAllowed:
    "Máximas infracciones del navegador permitidas",
  displayViolationsToCandidates: "Mostrar infracciones a los candidatos",
  actionWhenViolationLimitReached:
    "Acción cuando se alcanza el límite de infracción",
  flagged: "Marcado",
  terminate: "Terminar",
  stakeholdersAndFeedback: "Partes interesadas y comentarios",
  owner: "Dueño",
  recruiter: "Reclutador",
  allowCandidateFeedback: "Permitir comentarios de candidatos",
  enableCandidateFeedbackDescription:
    "Permitir que los candidatos envíen comentarios después de completar la evaluación",
  schedulingAndTimerSettings: "Configuración de programación y temporizador",
  scheduleType: "Tipo de horario",
  loginWindow: "Ventana de inicio de sesión",
  durationBased: "Basado en duración",
  deadline: "Fecha límite",
  autoCompleteMode: "Modo de autocompletar",
  startDateAndTime: "Fecha y hora de inicio",
  loginWindowInMinutes: "Ventana de inicio de sesión (en minutos)",
  endDateAndTime: "Fecha y hora de finalización",
  timerEnabled: "Temporizador habilitado",
  assessmentRules: "Reglas de evaluación",
  assessmentPattern: "Patrón de evaluación",
  resultVisibility: "Visibilidad de resultados",
  passPercentage: "Porcentaje de aprobación",
  maximumAttemptsAllowed: "Intentos máximos permitidos",
  unlimitedAttempts: "Intentos ilimitados",
  attempt: "intentar",
  attempts: "intentos",
  coolOffPeriodBetweenAttempts: "Período de reflexión entre intentos",
  questionDisplaySettings: "Configuración de visualización de preguntas",
  showQuestionTitle: "Mostrar título de la pregunta",
  showQuestionTitleDescription:
    "Mostrar el título de la pregunta encima de cada pregunta",
  showHint: "Mostrar sugerencia",
  showHintDescription:
    "Habilitar sugerencias para ayudar al candidato durante la evaluación.",
  showExplanation: "Mostrar explicación",
  hintLoading: "Necesitas esperar antes de ver otra pista",
  allHintsShown: "No hay pistas pendientes",
  hideExplanation: "Ocultar explicación",
  showExplanationDescription:
    "Mostrar explicaciones después del envío de cada pregunta.",
  showQuestionMarks: "Mostrar signos de interrogación",
  showQuestionMarksDescription:
    "Mostrar el valor de calificación/puntuación para cada pregunta",
  showWatermark: "Mostrar marca de agua",
  showWatermarkDescription:
    "Mostrar el correo electrónico del candidato para cada pregunta como marca de agua.",
  questionPaperPreview: "Vista previa del documento de preguntas",
  questionPaperReview: "Revisión del cuestionario",
  createSchedule: "Crear horario",
  reviewerComments: "Comentarios del revisor",
  reviewComments: "Revisar comentarios",
  sendBackQuestionPaperPrompt:
    "¿Está seguro de que desea devolver este cuestionario?",
  moveQuestionPaperToDraftPrompt:
    "¿Está seguro de que desea pasar este cuestionario al borrador?",
  markQuestionPaperReadyToPublishPrompt:
    "¿Está seguro de que desea marcar este cuestionario como listo para publicar?",
  questionPaperStatusUpdatedSuccessfully:
    "¡El estado del cuestionario se actualizó exitosamente!",
  newVersionQuestionPaperCreatedSuccessfully:
    "¡Nueva versión del cuestionario creada con éxito!",
  questionPaperClonedSuccessfully: "¡El cuestionario se clonó con éxito!",
  startAddingQuestionsPreview:
    "Comience a agregar preguntas para obtener una vista previa aquí",
  bulkInviteParticipants: "Invitar participantes en masa",
  bulkInviteParticipantsDescription:
    "Invite a varios participantes a la vez cargando un archivo Excel precargado. Utilice la plantilla proporcionada para garantizar el formato correcto.",
  maxParticipantsPerFileNote:
    "Máximo 200 participantes por archivo. Las entradas duplicadas o no válidas se omitirán con un error.",
  downloadTemplate: "Descargar plantilla",
  creatingUser: "Creando usuario...",
  bulkInviteLabel: "Invitación masiva",
  createAndInvite: "Crear e invitar",
  myUploads: "Mis cargas",
  enterIndividualsForInvite:
    "Ingrese los nombres de una o más personas que desee invitar a la evaluación.",
  searchPeopleByEmailOrName: "Buscar personas por correo electrónico o nombre",
  noResultsFound: "No se encontraron resultados",
  loading: "Cargando..",
  or: "O",
  multipleEmailsInviteDescription:
    "Agregue varios correos electrónicos de usuarios, separados por comas, para invitar a varios usuarios a la evaluación.",
  addCandidates: "Agregar candidatos",
  pleaseEnterValidNameOrEmail:
    "Por favor ingrese un nombre válido o dirección de correo electrónico",
  pleaseEnterValidEmailAddress:
    "Por favor, introduce una dirección de correo electrónico válida",
  someEmailsCouldNotBeAdded:
    "No se pudieron agregar algunas direcciones de correo electrónico",
  checkInvalidEmailIds:
    "Verifique los siguientes ID de correo electrónico; parecen no ser válidos:",
  failedToSendInvitesFollowingEmails:
    "No se pudieron enviar invitaciones a los siguientes correos electrónicos:",
  successfullyInvitedMembers: "Miembro {{count}} invitado exitosamente",
  validationFailed: "La validación falló",
  excelUploadedSuccessfully: "Excel cargado con éxito",
  invalidBulkNominationTemplate: "Plantilla de nominación masiva no válida",
  actionCompletedWithWarnings:
    "Acción completada con las siguientes advertencias:",
  actionFailedWithErrors:
    "No se pudo completar la acción y salir con los siguientes errores:",
  trackBulkOperationsAndResults:
    "Realice un seguimiento de todas sus operaciones masivas y sus resultados",
  partiallySaved: "Parcialmente guardado",
  statusInitiatedDescription:
    "La solicitud de actualización de preguntas se ha enviado y se está procesando.",
  statusCompletedDescription:
    "Todas las preguntas seleccionadas se actualizaron correctamente.",
  statusFailedDescription:
    "Ninguna de las preguntas seleccionadas pudo procesarse exitosamente.",
  statusPartiallySavedDescription:
    "Algunas preguntas se guardaron correctamente, mientras que otras tuvieron problemas.",
  draftReadyToPublishToPublish: "Borrador/Listo para publicar -> Publicar",
  actionType: "Tipo de acción",
  uploadedOn: "Subido en",
  viewDetails: "Ver detalles",
  loadingRecords: "Cargando registros...",
  noRecordsFound: "No se encontraron registros",
  recordsPerPage: "Registros por página:",
  page: "Página",
  untitledQuestion: "Pregunta sin título",
  globalLogic: "Lógica global",
  aiGenerated: "IA generada",
  fullScreen: "Pantalla completa",
  exitFullScreen: "Salir de pantalla completa",
  skills: "Habilidades",
  tags: "Etiquetas",
  allowedCodingLanguages: "Idiomas de codificación permitidos",
  marks: "marcas",
  lastUpdatedAt: "Última actualización en",
  solutionCode: "Código de solución",
  solution: "Solución",
  starterCode: "Código de inicio",
  options: "Opciones",
  explanation: "Explicación",
  hint: "Pista",
  deleteQuestion: "Eliminar pregunta",
  noSections: "No se agregaron secciones",
  editAndPublish: "Editar y publicar",
  sendBackToDraftInstruction:
    "Haga clic en el botón devolver para enviar la pregunta al borrador.",
  updateStatusReadyToPublishInstruction:
    "Haga clic en el botón Listo para publicar para actualizar el estado.",
  successfullyUpdatedStatus: "Actualizado exitosamente el estado",
  dismiss: "Despedir",
  ongoing: "En curso",
  toBeLaunched: "Por lanzarse",
  contentExpired: "Contenido vencido",
  notApplicable: "No aplica",
  expiresSoon: "Vence pronto",
  contentCreationInProgressTooltip:
    "La creación del contenido aún está en progreso y todavía no está disponible para los estudiantes",
  contentLiveAccessibleTooltip:
    "El contenido está activo y accesible para los estudiantes",
  contentAvailableWithinDatesTooltip:
    "El contenido está disponible actualmente, ya que se encuentra dentro de las fechas de inicio y vencimiento",
  contentNotLaunchedAvailableOnTooltip:
    "El contenido aún no se ha lanzado y estará disponible el",
  contentExpiredOnTooltip: "Este contenido venció el",
  statusAvailableAfterPublishTooltip:
    "El estado estará disponible una vez que el contenido esté publicado",
  contentExpiresWithin48HoursTooltip:
    "El contenido vencerá dentro de 48 horas.",
  moveToDraftOrCloneToEdit: "Muévelo a borrador o clónalo para hacer ediciones",
  webContent: "Contenido web",
  eLearning: "Aprendizaje en línea",
  untitledContent: "Contenido sin título",
  sendToDraft: "Enviar a borrador",
  sendToDraftPublishedInstruction:
    "Este contenido ya está publicado. Para hacer cambios, haz clic en el botón Enviar a borrador.",
  copyLinkForLearner: "Copiar enlace para el alumno",
  questionPaperName: "Nombre del cuestionario",
  type: "Tipo",
  duration: "Duración",
  minutes: "Minutos",
  difficultyLevel: "Nivel de dificultad",
  language: "Idioma",
  timezone: "Zona horaria",
  preferredLocation: "Ubicacion preferida",
  notSelected: "No seleccionado",
  selectedPreferencesHeading: "Preferencias seleccionadas",
  selectedPreferencesInfo:
    "Preferencias seleccionadas para una experiencia fluida",
  shortDescription: "Descripción corta",
  totalMarks: "Puntuación total",
  questionPaperInstructions: "Instrucciones del cuestionario",
  expiryDate: "Fecha de vencimiento",
  knowledgeCategory: "Categoría de conocimiento",
  category: "Categoría",
  subCategory: "Subcategoría",
  region: "Región",
  usage: "Uso",
  internalUseOnly: "Solo para uso interno",
  externalUseOnly: "Solo para uso externo",
  availableForAll: "Disponible para todos",
  apac: "APAC",
  emea: "EMEA",
  latinAmerica: "América Latina",
  northAmerica: "América del Norte",
  globalRegion: "Global",
  automotive: "Automotriz",
  bankingFinancialServicesInsurance: "Banca, servicios financieros y seguros",
  connectivitySolutionsCommunication: "Soluciones de conectividad/comunicación",
  consumerRetail: "Consumo y venta minorista",
  healthcareLifeSciences: "Salud y ciencias de la vida",
  manufacturingAndIndustrial: "Manufactura e industria",
  mediaEntertainment: "Medios y entretenimiento",
  technology: "Tecnología",
  other: "Otro",
  behavioralInterpersonal: "Conductual/Interpersonal",
  technical: "Técnico",
  processAndTools: "Procesos y herramientas",
  polishLanguage: "Polaco",
  spanishLanguage: "Español",
  japaneseLanguage: "Japonés",
  germanLanguage: "Alemán",
  ukrainianLanguage: "Ucraniano",
  swedishLanguage: "Sueco",
  romanianLanguage: "Rumano",
  slovakLanguage: "Eslovaco",
  croatianLanguage: "Croata",
  englishUsLanguage: "Inglés (EE. UU.)",
  englishUkLanguage: "Inglés (Reino Unido)",
  englishInLanguage: "Inglés (India)",
  netTech: "NET",
  aiMl: "AI/ML",
  automotiveStandardsProtocols: "Estándares y protocolos automotrices",
  businessAnalysis: "Análisis de negocio",
  cCpp: "C/C++",
  cloudDataScience: "Ciencia de datos en la nube",
  bigData: "Big Data",
  dataAnalytics: "Analítica de datos",
  databaseTech: "Base de datos",
  developmentTools: "Herramientas de desarrollo",
  devops: "DevOps",
  embedded: "Sistemas embebidos",
  javaTech: "Java",
  javaScriptTech: "JavaScript",
  linuxKernel: "Núcleo Linux",
  mobileDev: "Desarrollo móvil",
  networking: "Redes",
  operatingSystemsServers: "Sistemas operativos y servidores",
  otherTech: "Otro - Técnico",
  productivityTools: "Herramientas de productividad",
  programmingLangOther: "Lenguaje de programación - Otro",
  pythonTech: "Python",
  phpTech: "PHP",
  qaAqa: "QA / AQA",
  softwareEngineering: "Ingeniería de software",
  uxUi: "UX/UI",
  architectureTech: "Arquitectura",
  golang: "Golang",
  requirementEngineeringTechnicalWriting:
    "Ingeniería de requisitos/Redacción técnica",
  onboarding: "Incorporación",
  glTools: "Herramientas GL",
  processAndPolicies: "Procesos y políticas",
  communicationSubCategory: "Comunicación",
  personalEffectiveness: "Efectividad personal",
  methodologies: "Metodologías",
  projectManagement: "Gestión de proyectos",
  peopleManagement: "Gestión de personas",
  leadershipPrograms: "Programas de liderazgo",
  domain: "Dominio",
  reviewer: "Revisor",
  none: "Ninguno",
  questionPaperPreviewBreadcrumb: "Vista previa del cuestionario: {{title}}",
  questionPaperInReviewContactReviewer:
    "Este cuestionario está actualmente en revisión. Por favor, contacta al revisor.",
  randomization: "Aleatorización",
  randomizationInSectionDescription:
    "Las preguntas de esta seccion se mostraran a los candidatos en orden aleatorio",
  questionPreviewPlaceholderImage:
    "Marcador de posición de vista previa de pregunta",
  createNewVersionPromptWithNumber: "¿Crear nueva versión (V{{version}})?",
  questionPreviewBreadcrumb: "Vista previa de pregunta: {{title}}",
  questionPreviewTitle: "Vista previa de pregunta",
  adminView: "Vista de administrador",
  candidateView: "Vista de candidato",
  viewAsCandidate: "Ver como candidato",
  closePanel: "Cerrar panel",
  internalQuestion: "Pregunta interna",
  expiresOn: "Expira el",
  expiredLabel: "Expirado",
  solutionNotAdded: "Solucion no agregada",
  testCases: "Casos de prueba",
  testCasesNotAdded: "Casos de prueba no agregados",
  starterCodeNotAdded: "Codigo inicial no agregado",
  groupTitleLengthValidation:
    "El titulo del grupo debe tener mas de 5 y menos de 120 caracteres",
  addTitleHere: "Agrega el titulo aqui...",
  groupUpdatedSuccessfully: "Grupo actualizado correctamente",
  groupDeletedSuccessfully: "Grupo eliminado correctamente",
  group: "Grupo",
  numberOfQuestionsToBeShown: "Numero de preguntas que se mostraran",
  questionLimitPerSectionDescription:
    "Muestra solo una cierta cantidad de preguntas a los candidatos en las secciones",
  numberOfQuestionsToShow: "Numero de preguntas a mostrar {{picked}}/{{total}}",
  collapseGroup: "Contraer grupo",
  expandGroup: "Expandir grupo",
  groupSetupStartAddingQuestions:
    "Se configuro un grupo para esta seccion. Comienza a agregar preguntas.",
  addMoreQuestions: "Agregar mas preguntas",
  addQuestionFromLibrary: "Agregar pregunta desde la biblioteca",
  questionDeletedSuccessfully: "Pregunta eliminada correctamente",
  questionsShownCountUpdated: "Se actualizo el numero de preguntas mostradas",
  failedToDeleteQuestion: "No se pudo eliminar la pregunta",
  caseSensitive: "Distingue mayusculas y minusculas",
  caseSensitiveDescription:
    "Si esta habilitado, los alumnos deben ingresar la respuesta con exactamente las mismas mayusculas y minusculas.",
  enterYourAnswerBelow: "Ingresa tu respuesta abajo",
  caseSensitiveAnswerInfo:
    "Esta pregunta distingue mayusculas y minusculas, asi que ingresa tus respuestas con las mayusculas y minusculas exactas.",
  answerWithNumber: "Respuesta {{number}}",
  inviteEmailsPlaceholder: "usuario1@globallogic.com,usuario2@globallogic.com",
  visibleTestCases: "Casos de prueba visibles",
  hiddenTestCases: "Casos de prueba ocultos",
  visibleLabel: "Visible",
  hiddenLabel: "Oculto",
  responseSetting: "Configuracion de respuesta",
  recordingLimit: "Limite de grabacion",
  minimumResponseDuration: "Duracion minima de respuesta",
  uploadLimit: "Limite de carga",
  practiceAllowed: "Practica permitida",
  standardEvaluationRubricInfo:
    "Esta es la rubrica de evaluacion estandar que se utilizara para evaluar la respuesta del candidato a esta pregunta.",
  criteria: "Criterios",
  weightPercentage: "Peso(%)",
  viewRemarks: "Ver comentarios",
  input: "Entrada",
  expectedOutput: "Salida esperada",
  actualOutput: "Salida real",
  untitledSection: "Sección sin título",
  testSectionDescription: "Descripción de la sección de prueba",
  groupAddedSuccessfully: "Grupo añadido correctamente",
  addGroupToSection: "Agregar grupo a la sección",
  deleteSection: "Eliminar sección",
  questionPaperDetails: "Detalles del documento de preguntas",
  skillsInfoMessage:
    "Enumere las habilidades clave que este documento de preguntas pretende evaluar.",
  contentSettings: "Configuración de contenido",
  stakeholderAndReview: "Partes interesadas y revisión",
  statusType: "Tipo de estado",
  notReviewed: "No revisado",
  sourceType: "Tipo de fuente",
  proficiency: "Competencia",
  beginner: "Principiante",
  intermediate: "Intermedio",
  advanced: "Avanzado",
  wecp: "WECP",
  enterMarks: "Introducir marcas",
  removeSkill: "Quitar habilidad",
  searchSkills: "Habilidades de búsqueda",
  noSkillsFound: "No se encontraron habilidades.",
  enterTag: "Introduce una etiqueta",
  enterOwner: "Ingrese el propietario",
  enterReviewer: "Ingrese el revisor",
  noUserWithRole: "No se encontró ningún usuario con este rol",
  createSection: "Crear sección",
  untitledGroup: "Grupo sin título",
  createGroup: "Crear grupo",
  collapseSections: "Contraer secciones",
  expandSections: "Expandir secciones",
  assessmentNamePlaceholder: "Por favor ingrese el nombre de la evaluación",
  questionPaperTitleInfo:
    "Introduzca un título claro y descriptivo para el cuestionario.",
  shortDescriptionPlaceholder: "Proporcionar una breve descripción",
  shortDescriptionInfo:
    "Un breve resumen que explica lo que cubre el cuestionario.",
  questionPaperInstructionsInfo:
    "Escriba las instrucciones que los candidatos verán antes de comenzar el cuestionario. Incluya detalles importantes como reglas de sección, formatos de preguntas, consejos de navegación y pautas de envío.",
  questionPaperInstructionsPlaceholder:
    "Agregue instrucciones importantes para los alumnos antes de que comiencen la evaluación: duración, criterios de aprobación, herramientas permitidas o pautas.",
  totalMarksAutoCalculatedInfo:
    "Las calificaciones totales se calcularán automáticamente en función del número de preguntas seleccionadas para cada grupo. Si el número de preguntas a mostrar se establece en 0, ese grupo quedará excluido de la puntuación total.",
  questionPaperType: "Tipo de documento de preguntas",
  questionPaperTypeInfo: "Seleccione el formato del cuestionario.",
  durationInfo:
    "Establezca el límite de tiempo total para completar el cuestionario (en minutos).",
  difficultyLevelInfo:
    "Seleccione el nivel de dificultad esperado según la experiencia del candidato.",
  languageInfo: "Elija el idioma en el que se presentará el cuestionario.",
  tagsInfo:
    "Agregue palabras clave para ayudar a otros a encontrar este cuestionario mediante una búsqueda.",
  selectCategory: "Seleccionar categoría",
  createLevel: "Crear",
  evaluate: "Evaluar",
  analyze: "Analizar",
  apply: "Aplicar",
  understand: "Entender",
  remember: "Recordar",
  allowedCodingLanguagesRequiredInfo:
    "El campo es obligatorio solo cuando agrega preguntas de codificación al cuestionario.",
  knowledgeCategoryInfo:
    "Seleccione el nivel de habilidad cognitiva al que se dirige este cuestionario, por ejemplo, recordar, comprender, aplicar.",
  allowedCodingLanguagesInfo:
    "Seleccione los lenguajes de programación permitidos para codificar preguntas en este cuestionario.",
  expiryDateInfo:
    "Establezca una fecha opcional después de la cual este cuestionario ya no deberá utilizarse.",
  visibilityInfo: "Seleccione la visibilidad del cuestionario.",
  visibilityLockedInfo:
    "Una vez que un cuestionario se publica con visibilidad pública, todas sus demás versiones también tendrán visibilidad pública. Del mismo modo, si se publica como Privado, todas las versiones seguirán siendo Privadas.",
  reviewRequired: "Revisión requerida",
  reviewRequiredLockedInfo:
    "La configuración 'Revisión requerida' se sincroniza en todas las versiones de un cuestionario. Si se publica alguna versión con la revisión habilitada o deshabilitada, se aplicará la misma configuración a todas las versiones y no se podrá editar individualmente.",
  reviewRequiredInfo:
    "Habilite si este cuestionario debe pasar por un proceso de revisión formal antes de publicarse.",
  savingData: "Guardando datos...",
  questionDataSavedSuccessfully:
    "Los datos de la pregunta se guardaron correctamente.",
  sendQuestionForReviewInstruction:
    "Haga clic en el botón Enviar para revisión para enviarlo al revisor para que lo revise.",
  publishQuestionInstruction:
    "Haga clic en el botón publicar para publicar la pregunta.",
  noLearningContentAddedAfterSelectingYes:
    "No se agregó contenido de aprendizaje después de seleccionar Sí",
  expectedTimeInMinutes: "Tiempo esperado (en minutos)",
  codingMarksAutoCalculatedInfo:
    "Esta calificación se calcula automáticamente en función de los casos de prueba ocultos agregados a esta pregunta.",
  skillsInfoMessageQuestion:
    "Proporcionar habilidades específicas que los participantes adquirirán a partir de preguntas.",
  skillsSubtitleQuestion:
    "Establecer las habilidades asociadas con esta pregunta",
  allowedCodingLanguagesInfoQuestion:
    "Elija los idiomas disponibles para resolver esta pregunta",
  selectCodingLanguages: "Seleccionar lenguajes de codificación",
  allLanguages: "Todos los idiomas",
  tagsInfoQuestion:
    "Proporcionar palabras clave para categorizar, describir e identificar el evento.",
  tagsSubtitleQuestion: "Establecer las etiquetas para una búsqueda rápida",
  knowledgeCategorySubtitleQuestion:
    "Ayuda a categorizar las preguntas por nivel de habilidad cognitiva.",
  explanationNotAvailableForSpeakingQuestion:
    "Explicación no disponible para la pregunta oral",
  ownerVersionSyncInfo:
    "Si cambiamos el propietario de esta versión también se actualizará en todas las versiones creadas.",
  ownerInfoMessage: "Seleccione el propietario principal de la pregunta.",
  ownerReviewerCannotBeSame:
    "El propietario y el revisor no pueden ser los mismos.",
  reviewerInfoMessage:
    "Seleccione una persona o un grupo de personas como revisor(es)",
  stakeholdersUpdatedSuccessfully:
    "¡Las partes interesadas se actualizaron correctamente!",
  unexpectedErrorCreatingNewVersion:
    "Se produjo un error inesperado al crear una nueva versión.",
  previewAndPublish: "Vista previa y publicación",
  viewAnalytics: "Ver análisis",
  cloneQuestionPrompt: "¿Quieres clonar esta pregunta?",
  evaluationRubric: "Rúbrica de evaluación",
  problemStatement: "Declaración del problema",
  problemStatementPlaceholder:
    "Ingrese el enunciado del problema o el enunciado del cuestionario",
  addOptionsAndMarkCorrectAnswer:
    "Añade opciones y marca la respuesta correcta.",
  markCorrectAnswer: "Marca la respuesta correcta",
  addCorrectAnswer: "Añadir respuesta correcta",
  enterCorrectAnswerForBlank:
    "Ingrese la respuesta correcta para el espacio en blanco {{number}}",
  blankWithNumber: "En blanco {{number}}",
  addProblemStatementWithBlankToEnableAnswer:
    "Agregue un enunciado del problema adecuado con un '& espacio en blanco' para habilitar la respuesta.",
  enterSolution: "Ingrese la solución",
  enterExplanation: "Ingrese la explicación",
  codingSolutionExplanationPlaceholder:
    "Explique brevemente la lógica, el enfoque y los casos extremos manejados en la solución óptima.",
  optionWithNumber: "Opción {{number}}",
  enterExplanationForAnswer:
    "Ingrese la explicación de la respuesta {{number}}",
  addOptionToEnableExplanation:
    "Agregue la opción {{number}} para habilitar la explicación.",
  enterExplanationForBlank:
    "Ingrese la explicación para el espacio en blanco {{number}}",
  addProblemStatementWithBlankToEnableExplanation:
    "Agregue un enunciado del problema adecuado con un '& espacio en blanco' para habilitar la explicación.",
  enterHint: "Introduce la pista",
  addUpTo3Hints: "Añade hasta 3 pistas",
  addMoreOptions: "Agregar más opciones",
  answer: "Respuesta",
  exitCodeBlockInfo:
    'Para salir del bloque de código, vaya al final de la línea y haga clic en "Enter" tres veces',
  fibBlankInsertionInfo:
    'Para agregar un espacio en blanco, seleccione el texto y haga clic en el botón "Insertar espacio en blanco", o agregue manualmente &blankN, donde N puede ser cualquier número entero, por ejemplo: &blank1;',
  htmlEditorAccessInfo:
    "Para agregar código o tener control sobre el formato, puede acceder al editor HTML haciendo clic en el ícono de edición",
  skillSelectionCannotBeEmpty:
    "La selección de habilidades no puede estar vacía",
  maxDurationInfo:
    "Tiempo máximo permitido para que un usuario registre su respuesta a esta pregunta.",
  minDurationInfo:
    "Tiempo de grabación mínimo requerido que un usuario debe completar antes de enviar su respuesta.",
  uploadLimitInfo:
    "Número de veces que un usuario puede volver a grabar su respuesta antes del envío final.",
  textQuestionTitle: "Esta es una pregunta de texto.",
  audioRecordQuestionTitle: "Esta es una pregunta de grabación de audio.",
  audioUploadQuestionTitle: "Esta es una pregunta para subir audio.",
  videoRecordQuestionTitle: "Esta es una pregunta grabada en video.",
  videoUploadQuestionTitle: "Esta es una pregunta para subir un video.",
  subjectiveQuestionUploadConfigTitle:
    "Título de configuración de carga de pregunta subjetiva",
  recordingLimitInMinutes: "Límite de grabación (en min)",
  minimumResponseDurationInMinutes:
    "Duración mínima de la respuesta (en minutos)",
  recordingLimitLessThanTwenty: "El límite de grabación debe ser inferior a 20",
  recordingLimitGreaterThanOrEqualOne:
    "El límite de grabación debe ser mayor o igual a 1",
  minimumDurationLessThanRecordingLimit:
    "La duración mínima de la respuesta debe ser inferior al límite de grabación.",
  durationGreaterThanPointFive: "La duración debe ser mayor que 0,5",
  uploadLimitGreaterThanZero: "El límite de carga debe ser mayor que 0",
  addFieldSelectCodingLanguagesInfo:
    "Para agregar un {{fieldLabel}}, primero seleccione los idiomas de codificación permitidos en la sección '{{basicDetails}}'.",
  basicDetails: "Detalles básicos",
  loadingEditor: "Cargando editor...",
  run: "Ejecutar",
  writingSolutionInLanguage: "Actualmente estás escribiendo una solución en",
  changingToLanguageWillClearInput: "Cambiando a",
  unsavedChangesWillBeLostInLanguage: "Tus cambios no guardados en",
  changeLanguage: "Cambiar idioma",
  testCase: "Caso de prueba",
  add: "Agregar",
  addMinimumVisibleAndHiddenTestCasesInfo:
    "Agregue un mínimo de 2 casos de prueba visibles y 3 casos de prueba ocultos a continuación",
  visibleToCandidatesForSelfEvaluation:
    "Visible para los candidatos para la autoevaluación",
  noVisibleTestCasesAddedYet:
    "Aún no se han agregado casos de prueba visibles. Haga clic en el botón de abajo para agregar uno.",
  visibleTestCasesCannotExceedTwenty:
    "Los casos de prueba visibles no pueden ser más de 20",
  addMoreVisibleTestCases: "Agregar casos de prueba más visibles",
  maximumTestCasesLimitReached:
    "Se alcanzó el límite máximo de casos de prueba",
  hiddenToCandidatesRunsAfterSubmit:
    "Oculto para los candidatos, se ejecuta después de que el candidato envía",
  noHiddenTestCasesAddedYet:
    "Aún no se han agregado casos de prueba ocultos. Haga clic en el botón de abajo para agregar uno.",
  hiddenTestCasesCannotExceedTen:
    "Los casos de prueba ocultos no pueden ser más de 10",
  addMoreHiddenTestCases: "Agregar más casos de prueba ocultos",
  hiddenTestCase: "Caso de prueba oculto",
  visibleTestCase: "Caso de prueba visible",
  someQuestionsCouldNotBeUpdated:
    "Algunas preguntas no se pudieron actualizar. Revise las preguntas y vuelva a intentarlo.",
  publishSummary: "Publicar resumen",
  sendForReviewSummary: "Enviar para revisión Resumen",
  moveToDraftSummary: "Mover al borrador del resumen",
  actionSummary: "Resumen de acción",
  publishSummarySubtitle:
    "Aquí está el resumen de su acción de publicación. Revise los detalles a continuación.",
  sendForReviewSummarySubtitle:
    "Aquí está el resumen de su solicitud de revisión. Revise los detalles a continuación.",
  moveToDraftSummarySubtitle:
    "Aquí está el resumen de su paso a la acción de draft. Revise los detalles a continuación.",
  actionSummarySubtitle:
    "Aquí está el resumen de su acción. Revise los detalles a continuación.",
  successfully: "Exitosamente",
  failedTo: "No se pudo",
  moveToDraft: "Mover al borrador",
  details: "Detalles",
  questionTitle: "Título de la pregunta",
  reason: "Razón",
  showLess: "Mostrar menos",
  showMoreCount: "Mostrar {{count}} más",
  uploadedAllCountItems: "Subido todo {{count}} {{item}}",
  partiallyUploadedCountItems:
    "Subido parcialmente {{successCount}}/{{totalCount}} {{item}}",
  users: "usuarios",
  questions: "preguntas",
  viewErrors: "Ver errores",
  errorsWithFileName: "Errores: {{fileName}}",
  inputIsRequired: "Se requiere entrada",
  expectedOutputIsRequired: "Se requiere el resultado esperado",
  expectedOutputCannotBeBlank:
    "El resultado esperado no debe estar vacío ni solo espacios.",
  marksMustBeNumber: "Las marcas deben ser un número.",
  marksAreRequired: "Se requieren marcas",
  hiddenTestCaseMarksGreaterThanZero:
    "Las calificaciones para casos de prueba ocultos deben ser superiores a 0 para continuar.",
  hiddenTestCaseMarksMaxThirtyThousand:
    "Las calificaciones para casos de prueba ocultos no deben exceder los 30.000.",
  explanationMinFiveIfProvided:
    "La explicación debe tener al menos 5 caracteres si se proporciona.",
  explanationIsRequired: "Se requiere explicación",
  explanationMinFiveNotBlank:
    "La explicación debe tener al menos 5 caracteres y no solo espacios.",
  provideInput: "Proporcionar información",
  provideExpectedOutput: "Proporcionar el resultado esperado",
  enterScore: "Introducir puntuación",
  optional: "opcional",
  explainTestCase: "Explicar el caso de prueba.",
  updateTestCase: "Actualizar caso de prueba",
  addTestCase: "Agregar caso de prueba",
  deleteQuestionWithTitlePrompt:
    "¿Estás seguro de que deseas eliminar esta pregunta titulada '{{title}}'?",
  errorFetchingData: "Error al obtener datos",
  rowNumber: "Número de fila",
  columnName: "Nombre de columna",
  useCase: "Caso de uso",
  startsAt: "comienza en",
  endsAt: "Termina en",
  invite: "Invitar",
  viewReport: "Ver informe",
  successfullyDeletedAssessment: "Se eliminó correctamente la evaluación.",
  successfullyFreezeActionAssessment: "{{action}} exitosamente la evaluación",
  freezeOperationFailed: "Error en la operación de congelación",
  deleteAssessmentWithTitlePrompt:
    "¿Está seguro de que desea eliminar esta evaluación titulada '{{title}}'?",
  freeze: "Congelar",
  unfreeze: "Descongelar",
  freezeAssessmentPrompt:
    "¿Está seguro de que desea {{action}} esta evaluación?",
  expiresAt: "Vence en",
  seePreview: "Ver vista previa",
  schedule: "Cronograma",
  skillBenchmarking: "Evaluación comparativa de habilidades",
  skillBenchmarkingOverview:
    "Una descripción general del dominio del participante en habilidades específicas.",
  proctoringAnalysis: "Análisis de supervisión",
  proctoringAnalysisOverview:
    "Una descripción general rápida de los aspectos de la evaluación relacionados con la supervisión.",
  proctoringStatus: "Estado de supervisión",
  noIrregularitiesReported: "No se reportaron irregularidades.",
  monitoringOverview: "Descripción general del monitoreo",
  complianceNoIncidents:
    "Cumplimiento de las normas de evaluación; sin incidentes ni comportamientos señalados.",
  viewEvidenceClicked: "¡Evidencia hecha clic!",
  marksObtained: "Marcas obtenidas",
  correctAnswer: "Respuesta correcta",
  wrongAnswer: "Respuesta incorrecta",
  sectionWiseAnalysis: "Análisis por secciones",
  sectionWiseAnalysisOverview:
    "Una descripción general de cada pregunta y la respuesta del candidato.",
  openAllSections: "Abrir todas las secciones",
  closeAllSections: "Cerrar todas las secciones",
  sectionWithNumber: "Sección {{number}}:",
  score: "Puntaje",
  questionAnalysis: "Análisis de preguntas",
  questionTitleFallback: "Título de la pregunta",
  candidateAnswer: "Respuesta del candidato",
  loadAllQuestions: "Cargar todo {{count}} {{item}}",
  attemptWithNumber: "Intento #{{number}}",
  invalidReportUrl: "URL del informe no válida",
  failedToDownloadReportTryAgainLater:
    "No se pudo descargar el informe. ¡Inténtelo de nuevo más tarde!",
  downloadReport: "Descargar Informe",
  participantName: "Nombre del participante",
  dateOfAttempt: "Fecha del intento",
  fail: "Fallar",
  pass: "Aprobar",
  userScoredInAssessment: "{{name}} obtuvo {{percentage}} en la evaluación.",
  overallSummary: "Resumen general",
  sectionAnalytics: "Análisis de sección",
  allAttempts: "Todos los intentos",
  bestAttempt: "Mejor intento",
  latestAttempt: "Último intento",
  participantList: "Lista de participantes",
  totalParticipantsInvited: "Total de participantes invitados",
  notStarted: "No iniciado",
  inProgress: "En curso",
  resultsInProgress: "Resultados en progreso",
  searchByNameOrEmail: "Buscar por nombre o correo electrónico",
  noUsersAvailableReportCannotBeGenerated:
    "No hay usuarios disponibles: no se puede generar el informe.",
  userName: "Nombre de usuario",
  totalAttempt: "Intento total",
  percentage: "Porcentaje(%)",
  attemptTimeline: "Línea de tiempo del intento",
  noDataFound: "No se encontraron datos",
  outOfMarks: "{{obtained}} de {{max}} marcas",
  resultInProcess: "Resultado en proceso",
  participantNotFound: "¡Participante no encontrado!",
  searchedParticipantNotFound: "¡No se encontró el participante buscado!",
  noParticipantEnrolled: "¡No hay participantes inscritos!",
  noDataToDisplay: "No hay datos para mostrar",
  participantsPerPage: "Participantes por página:",
  actionFailed: "La acción falló",
  failedToRemoveUser: "No se pudo eliminar el usuario",
  bestScoreAcrossAttemptsInfo:
    "Indica la mejor puntuación obtenida en múltiples intentos.",
  successfullyRemovedUser: "Eliminado exitosamente al usuario",
  successfullyReinvitedUser: "Se volvió a invitar al usuario con éxito",
  reinviteTooltip:
    "Vuelva a invitar a los participantes que aún no han comenzado la evaluación en curso.",
  reInvite: "Volver a invitar",
  noParticipantsInvitedYet: "Aún no se ha invitado a ningún participante",
  scheduleExpired: "Horario vencido",
  assessmentIsOngoing: "La evaluación está en curso",
  assessmentCompleted: "Evaluación completada",
  resultNotProcessed: "Resultado no procesado",
  assessmentNotStarted: "Evaluación no iniciada",
  remove: "Eliminar",
  confirmReInvitation: "Confirmar reinvitación",
  confirmReinviteMessage:
    "¿Está seguro de que desea volver a invitar a los participantes que aún no han comenzado la evaluación en curso?",
  removeUserWithNamePrompt: "¿Está seguro de que desea eliminar '{{name}}'?",
  groupType: "Tipo de grupo",
  objectiveGroupType: "Objetivo",
  codingGroupType: "Codificación",
  subjectiveTextSpeakingGroupType: "Subjetivo ( Texto / Habla )",
  groupTypeImmutableInfo:
    "El tipo de grupo no se puede cambiar más adelante. Sólo se pueden agregar preguntas de ese tipo.",
  sameMarkGroupingTitle:
    "Las preguntas sólo se pueden agrupar si tienen el mismo valor de puntuación.",
  sameMarkGroupingDescription:
    "Mezclar valores de calificaciones (por ejemplo, 2 puntos y 5 puntos) en un grupo puede generar diferentes puntajes de sección cuando solo se eligen algunas preguntas. Agrupe preguntas con calificaciones similares para mantener puntuaciones consistentes.",
  searchQuestion: "Pregunta de búsqueda",
  addAllSelectedQuestions:
    "Agregue todas las {{count}} preguntas seleccionadas",
  singleQuestionSelectedCount: "{{count}} pregunta seleccionada",
  allQuestionsSelectedCount: "Todas las {{count}} preguntas seleccionadas",
  selectedCountOfTotalQuestions:
    "Seleccionadas {{selected}} de {{total}} {{label}}",
  addSelectedQuestion: "Añade la pregunta seleccionada",
  validationErrors: "Errores de validación",
  failedToAddToGroup: "No se pudo agregar al grupo",
  questionsAddedSuccessfullyWithCount:
    "{{count}} preguntas agregadas exitosamente",
  successfullyUpdatedAssessment: "Evaluación actualizada con éxito",
  editCustomTnc: "Editar términos y condiciones personalizados",
  addCustomTnc: "Añadir términos y condiciones personalizados",
  attributes: "Atributos",
  added: "Añadidos",
  addAttributes: "Añadir atributos",
  clickHereToAddEditAttributes: "Haga clic aquí para añadir o editar atributos",
  clickHereToAddAttributes: "Haga clic aquí para añadir atributos",
  addTncAndSave: "Añadir términos y condiciones y guardar",
  savedWithFollowingErrors: "Guardado con los siguientes errores",
  selectDomain: "Seleccionar dominio",
  selectRegion: "Seleccionar región",
  selectUsage: "Seleccionar uso",
  selectCategoryFirst: "Seleccione primero una categoría",
  selectSubCategory: "Seleccionar subcategoría",
  addAttributesAndSave: "Añadir atributos y guardar",
  questionPaperTimer: "Temporizador de la prueba de preguntas",
  sectionLevelTimer: "Temporizador por sección",
  questionLevelTimer: "Temporizador por pregunta",
  loginWindowDescription:
    "Los candidatos solo pueden unirse dentro de un período de tiempo limitado después de la hora de inicio.",
  durationBasedDescription:
    "La hora de finalización se calcula automáticamente a partir de la hora de inicio + la duración de la prueba.",
  deadlineDescription:
    "Hora de inicio y finalización fijas; los candidatos deben terminar antes de la fecha límite.",
  loginWindowInfo:
    "La ventana de inicio de sesión es el tiempo (en minutos) durante el cual los candidatos pueden comenzar la evaluación después de la hora de inicio programada. Una vez que se cierra la ventana de inicio de sesión, no puede ingresar ningún candidato nuevo. La ventana de inicio de sesión debe ser menor o igual a la duración del examen.",
  assessmentDurationInfo:
    "Configure solo la hora de inicio. El sistema calculará automáticamente la hora de finalización sumando la duración de la prueba.",
  startTimeMinAheadInfo:
    "La hora de inicio debe ser al menos 15 minutos posterior a la hora actual.",
  loginWindowExample:
    "Ejemplo: Si la hora de inicio son las 9:00 AM y la ventana de inicio de sesión es de 30 minutos, los candidatos pueden comenzar entre las 9:00 y las 9:30 AM con un margen adicional de 5 minutos.",
  assessmentDurationExample:
    "Ejemplo: Si la hora de inicio son las 9:00 AM y la duración de la prueba es de 60 minutos, la evaluación finalizará a las 10:00 AM con un margen adicional de 5 minutos.",
  freeFlow: "Flujo libre",
  oneByOne: "Uno por uno",
  subjectiveNoResultInfo: "Información subjetiva sobre 'Sin resultado'",
  candidateResultVisibility: "Visibilidad de los resultados para el candidato",
  noResult: "Sin resultado",
  passPercentageRangeError: "Error en el rango del porcentaje de aprobación",
  attemptsAllowedInfo: "Información sobre intentos permitidos",
  maxAttemptsError: "Error: Número máximo de intentos excedido",
  maximumAttemptsInfo: "Información sobre el límite máximo de intentos",
  limitedAttempts: "Intentos limitados",
  coolOffDescription: "Descripción del periodo de espera",
  noCoolOffPeriod: "Sin periodo de espera",
  waitFor: "Esperar",
  hours: "Horas",
  days: "Días",
  whatLearnersWillSee: "Lo que verán los estudiantes",
  unlimitedAttemptsInfo:
    "Tiene intentos ilimitados disponibles para esta evaluación.",
  waitBeforeNextAttemptPrefix: "Después de cada intento, deberá esperar",
  waitBeforeNextAttemptSuffix: "antes de comenzar su siguiente intento.",
  waitBeforeNextAttempt:
    "Después de cada intento, deberá esperar {duration} antes de comenzar su siguiente intento.",
  singleAttemptInfo: "Tiene 1 intento disponible para esta evaluación.",
  remainingAttemptsInfoPrefix: "Tiene",
  remainingAttemptsInfoMiddle: "de",
  remainingAttemptsInfoSuffix: "intentos disponibles para esta evaluación.",
  remainingAttemptsInfo:
    "Tiene {remaining} de {total} intentos disponibles para esta evaluación.",
  enableCertificate: "Activar certificado",
  enableCertificateDescription:
    "Emita un certificado a los candidatos al completar con éxito la evaluación.",
  maxAllowed100: "Máximo permitido 100",
  scheduleAssessment: "Programar evaluación",
  privateAssessmentLabel: "Evaluación privada",
  publicAssessmentLabel: "Evaluación pública",
  privateAssessmentDescription:
    "Esta evaluación es solo por invitación y está disponible estrictamente dentro de la ventana definida de inicio y fin.",
  publicAssessmentDescription:
    "Esta evaluación admite tanto el acceso autoasignado como el basado en invitación, sin una ventana de acceso fija.",
  schedulePublicAssessment: "Programar evaluación pública",
  successfullyPublishedAssessment: "Evaluación publicada con éxito",
  publishWithoutProctoringPrompt:
    "¿Publicar sin supervisión remota (proctoring)?",
  publishAssessmentPrompt: "¿Publicar evaluación?",
  sectionScoreAnalysis: "Análisis de puntuación por sección",
  sectionScoreAnalysisOverview:
    "Resumen del análisis de puntuación por sección",
  section: "Sección",
  noSectionDataAvailable: "No hay datos disponibles para la sección",
  difficultyLevelAnalysis: "Análisis del nivel de dificultad",
  browserViolations: "Infracciones del navegador",
  videoViolations: "Infracciones de video",
  times: "Veces",
  statusMessageUnavailable: "Mensaje de estado no disponible",
  viewViolationEvidence: "Ver pruebas de la infracción",
  noBrowserViolationsDetected: "No se detectaron infracciones del navegador",
  noVideoViolationsDetected: "No se detectaron infracciones de video",
  candidateNotAttemptedCodingMessage:
    "Mensaje: El candidato no ha intentado la prueba de programación",
  candidateCode: "Código del candidato",
  candidateScore: "Puntuación del candidato",
  compilationCount: "Número de compilaciones",
  submissionCount: "Número de entregas",
  timeTaken: "Tiempo empleado",
  testCaseReport: "Informe de casos de prueba",
  performanceAndCompilationMetrics: "Métricas de rendimiento y compilación",
  totalTestCases: "Total de casos de prueba",
  testCasesPassed: "Casos de prueba aprobados",
  testCaseDetails: "Detalles del caso de prueba",
  searchQuestions: "Buscar preguntas",
  clearSearch: "Borrar búsqueda",
  question: "pregunta",
  isSelected: "está seleccionado/a",
  areSelected: "están seleccionados/as",
  selected: "Seleccionado/a",
  questionsPerPage: "Preguntas por página:",
  publishQuestions: "Publicar preguntas",
  send: "Enviar",
  move: "Mover",
  publishQuestionsConfirmation:
    "¿Está seguro de que desea publicar {{count}} {{label}}?",
  sendForReviewConfirmation:
    "¿Está seguro de que desea enviar {{count}} {{label}} para revisión?",
  moveToDraftConfirmation:
    "¿Está seguro de que desea mover {{count}} {{label}} a borradores?",
  bulkPublishDisclaimer:
    "Por favor, verifique que todas las preguntas seleccionadas estén completas, sean precisas y se muestren como se desea antes de publicarlas.",
  bulkReviewDisclaimer:
    "Por favor, verifique que todas las preguntas seleccionadas estén completas, sean precisas y se muestren como se desea antes de enviarlas a revisión.",
  bulkDraftDisclaimer:
    "Por favor, verifique que todas las preguntas seleccionadas estén completas, sean precisas y se muestren como se desea antes de moverlas a borradores.",
  questionsUnderProcess:
    "Las preguntas están siendo procesadas, por favor haga clic en ver detalles para comprobar el estado de las preguntas.",
  mixedStatusesSelected: "Estados mixtos seleccionados",
  mixedStatusesWarning:
    "Por favor, asegúrese de que todas las preguntas seleccionadas tengan el mismo estado antes de continuar.",
  selectionLimitReached: "Límite de selección alcanzado",
  selectionLimitWarning:
    "No puede seleccionar más de {{count}} preguntas para una acción masiva. Desactive una pregunta antes de seleccionar otra.",
  knowMore: "Saber más",
  guideLearnersRightDepth:
    "Guíe a sus alumnos con preguntas que se ajusten a la profundidad adecuada.",
  bloomCreateDescription:
    "Evaluar la capacidad del estudiante para diseñar, estructurar o construir nuevos sistemas o soluciones de código utilizando múltiples conceptos.",
  bloomEvaluateDescription:
    "Comprobar si el estudiante puede evaluar críticamente el código, justificar elecciones o valorar diferentes soluciones.",
  bloomAnalyzeDescription:
    "Probar la capacidad del estudiante para desglosar el código, depurar, rastrear la lógica o identificar patrones en sistemas técnicos.",
  bloomApplyDescription:
    "Evaluar si el estudiante puede aplicar conceptos para resolver problemas prácticos de programación o escenarios del mundo real.",
  bloomUnderstandDescription:
    "Comprobar si el estudiante puede comprender y explicar conceptos con sus propias palabras o interpretar comportamientos.",
  bloomRememberDescription:
    "Evaluar la capacidad del estudiante para recordar definiciones básicas, sintaxis e información factual.",
  bloomVerbCreate: "Crear",
  bloomVerbDesign: "Diseñar",
  bloomVerbConstruct: "Construir",
  bloomVerbDevelop: "Desarrollar",
  bloomVerbEvaluate: "Evaluar",
  bloomVerbJustify: "Justificar",
  bloomVerbDefend: "Defender",
  bloomVerbAssess: "Valorar",
  bloomVerbAnalyze: "Analizar",
  bloomVerbDifferentiate: "Diferenciar",
  bloomVerbOrganize: "Organizar",
  bloomVerbCompare: "Comparar",
  bloomVerbApply: "Aplicar",
  bloomVerbUse: "Utilizar",
  bloomVerbDemonstrate: "Demostrar",
  bloomVerbSolve: "Resolver",
  bloomVerbExplain: "Explicar",
  bloomVerbDescribe: "Describir",
  bloomVerbSummarize: "Resumir",
  bloomVerbInterpret: "Interpretar",
  bloomVerbList: "Listar",
  bloomVerbDefine: "Definir",
  bloomVerbName: "Nombrar",
  bloomVerbRecall: "Recordar",
  bloomVerbRecognize: "Reconocer",
  bloomCreateExample1:
    "Crear una aplicación de una sola página utilizando React y Redux.",
  bloomCreateExample2:
    "Diseñar un esquema para la base de datos de una aplicación de viajes compartidos.",
  bloomCreateExample3:
    "Desarrollar un flujo de trabajo CI/CD utilizando GitHub Actions.",
  bloomEvaluateExample1:
    "Evaluar los pros y los contras de usar NoSQL frente a SQL en una arquitectura de microservicios.",
  bloomEvaluateExample2:
    "Recomendar mejoras para optimizar el rendimiento del componente React.",
  bloomAnalyzeExample1: "Comparar el rendimiento de merge sort y quicksort.",
  bloomAnalyzeExample2: "Analizar el uso de memoria de esta función recursiva.",
  bloomAnalyzeExample3:
    "Categorizar los errores en este bloque de código JavaScript.",
  bloomApplyExample1:
    "Aplicar el algoritmo de búsqueda binaria para encontrar un elemento en un array.",
  bloomApplyExample2:
    "Utilizar un bucle para imprimir la serie de Fibonacci en Python.",
  bloomApplyExample3:
    "Resolver un problema del mundo real utilizando un hash map.",
  bloomUnderstandExample1:
    "Explicar cómo funciona una pila utilizando el principio LIFO.",
  bloomUnderstandExample2:
    "Describir la diferencia entre var, let y const en JavaScript.",
  bloomUnderstandExample3: "Interpretar el resultado de la consulta SQL dada.",
  bloomRememberExample1:
    "Identificar la etiqueta HTML correcta para crear un hipervínculo.",
  bloomRememberExample2:
    "Nombrar los cuatro pilares de la Programación Orientada a Objetos (POO).",
  bloomRememberExample3: "Listar los tipos de datos primitivos en Java.",
  commonVerbs: "Verbos comunes",
  exampleQuestions: "Preguntas de ejemplo",
  noExamplesAvailable: "No hay ejemplos disponibles.",
  candidateResponse: "Respuesta del candidato",
  correctQuestions: "Preguntas correctas",
  totalQuestions: "Total de preguntas",
  correctQuestionPercentage: "Porcentaje de preguntas correctas",
  performance: "Rendimiento",
  level: "NIVEL",
  noOfQuestions: "NÚMERO DE PREGUNTAS",
  correctAttempts: "INTENTOS CORRECTOS",
  correctness: "CORRECCIÓN",
  partiallyCorrect: "PARCIALMENTE CORRECTO",
  partiallyCorrectPercentage: "PORCENTAJE PARCIALMENTE CORRECTO",
  rescheduleAssessmentPrompt:
    'Por favor, confirme si desea reprogramar la evaluación titulada "{{title}}"',
  assessmentAlreadyStarted: "La evaluación ya ha comenzado",
  readMore: "Leer más",
  best: "Destacados",
  latest: "Últimos",
  allQuestions: "Todas las preguntas",
  myQuestions: "Mis preguntas",
  publicQuestions: "Preguntas públicas",
  remarks: "Observaciones",
  addRemarks: "Agregar observaciones",
  noGroupsAdded: "Aún no se han añadido grupos",
  addGroupInfo:
    "Comience creando un grupo para empezar a añadir preguntas. Haga clic en el botón „Añadir grupo a la sección“ de abajo para comenzar.",
  exitPreview: "Salir de la vista previa",
  preview: "Vista previa",
  problemStatementNotAdded: "No se ha añadido la declaración del problema",
  durationDayUnit: "día",
  durationDaysUnit: "días",
  durationHourUnit: "h",
  durationHoursUnit: "h",
  durationMinuteUnit: "min",
  customFieldAddedForSingleLanguage:
    "Campo personalizado {{fieldLabel}} agregado para {{current}} de {{total}} idioma",
  customFieldAddedForMultipleLanguages:
    "Campo personalizado {{fieldLabel}} agregado para {{current}} de {{total}} idiomas",
  email: "Correo electrónico",
  tagInputHint: "Agregar separados por comas",
  enterOptions: "Ingresar opciones",
  groupNotFound: "Grupo no encontrado",
  sheetNotFound: "Hoja no encontrada",
  missingHeaders: "Faltan los encabezados requeridos",
  assetNotFound: "Recurso no encontrado",
  noValidDataFound: "No se encontraron datos válidos",
  notFoundPID: "Participante no encontrado.",
  invalidParticipants: "Participante no válido.",
  alreadyAdded: "Participante ya agregado.",
  duplicateData: "Se encontraron datos duplicados.",
  invalidData: "Datos no válidos.",
  warnings: "Advertencias",
  assignedToMyself: "Asignado a mí (Aprendizaje Autónomo)",
  assignedByMe: "Asignado por mí (Mis Tareas)",
  urlCopiedToClipboard: "¡URL copiada al portapapeles!",
  failedToCopyUrl: "Error al copiar la URL.",
  content: "Contenido",
  platformHelp: "Ayuda de la plataforma",
  privacyPolicy: "Política de privacidad",
  logout: "Cerrar sesión",
  logoutConfirmTitle: "¿Seguro que quieres cerrar sesión?",
  logoutConfirmDescription:
    "¿Ya te vas? Siempre puedes volver y continuar donde lo dejaste.",
  stayEngaged: "Seguir conectado"
} as const;
export default es;
